// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
}); // This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// ギフトセットのアコーディオン処理
// 「infiniteoptions-container」をクリックした場合
document.addEventListener('click', function (event) {

  // クリックした際のIDを取得
  let clickedElement = event.target;
  let clickedElementId = clickedElement.id;

  // infiniteoptions-containerの要素を取得
  let container = document.getElementById('infiniteoptions-container');

  if (container == null || container == undefined)
  {
    return;
  }
  
  // container内の要素を取得（IDを持っていなかったので、「aria-labelledby」から取得する。）
  let elements = container.querySelectorAll('[aria-labelledby="' + clickedElementId + '"]');

  // クリックした際のIDが該当箇所(variation_1-0-0など)以外は処理しない。
  if (elements[0] === undefined) {
    return;
  }
  // IDで取得すると、divタグとspanタグがぶら下がっている。(spanタグが欲しい)
  if (1 > elements[0].children.length) {
    return;
  }

  // ぶら下がっているエレメントを取得する。
  let element = elements[0].children[1];

  // ラジオボタン要素を取得します
  let labels = element.querySelectorAll('input');

  // 各label要素にクリックイベントリスナーを追加
  labels.forEach(function(label) {
      label.addEventListener('click', function(event) {
      // 選択商品のデータ取得
      ShowGiftSetProductDetail();
  });
});
  
  // 現在の表示・非表示の状態を取得する。
  let newStyleRule = '';

  // 商品の表示・非表示の切り替えを行う。
  if (element.style.display === 'none' || element.style.display === '') {
    newStyleRule = '#' + clickedElementId + '::after { display: none; }';
    element.style.display = 'block'
  }
  else {
    // 新しいスタイルルールを作成
    newStyleRule = '#' + clickedElementId + '::after { display: block; }';
    element.style.display = 'none'
  }
  // <style>タグを作成し、CSSルールを追加
  let styleTag = document.createElement('style');
  styleTag.innerHTML = newStyleRule;
  // 疑似CSSはこうしないとダメみたい。
  document.head.appendChild(styleTag);
});

/*
 * ギフトセットの価格小計
 */
function ShowGiftSetProductDetail ()
{
  let container = document.getElementById('infiniteoptions-container');
  let productList = document.getElementById('productList');
  let pTagsProductList = productList.getElementsByTagName('p');

  // クリックされた際の処理をここに記述します
  let productData = container.querySelectorAll('input[type="radio"]:checked');

  var newElementList = []; // 新しい<p>要素のリストを作成
  let divElement = document.getElementById('giftPrice');

  // ギフトセットの金額を取得
  let giftPrice = document.querySelector('span[data-price]').innerHTML;

  // 通貨取得
  let currency = giftPrice.replace(/[0-9]/g, '').replace(",","").replace(".","");
  let allPrice = giftPrice.replace(currency, "");
  // 通貨ごとにカンマ、コンマの扱い方が違う
  switch(currency) {
    case "€":
    // カンマは小数点
      allPrice = Number(allPrice.replace(",", "."));
      break;
    case "₡ ":
      // コンマはカンマらしい
      allPrice = Number(allPrice.replace(",", "").replace(".","")) / 100;
      break;
    // 通貨にコンマが混じる場合
    case "Rs .":
        currency = "Rs. ";
        allPrice = Number(allPrice.replace(currency, ""));
        break;
    case "Gs .":
        currency = "Gs. ";
        allPrice = Number(allPrice.replace(currency, "")) * 100;
        break;
    case "S/ .":
        currency = "S/. ";
        allPrice = Number(allPrice.replace(currency, ""));
        break;
    case "Dhs .":
        currency = "Dhs. ";
        allPrice = Number(allPrice.replace(currency, ""));
        break;
    case "$":
        if (Shopify.currency.active == "UYU") {
          allPrice = Number(allPrice.replace(",", "")) / 100;
        } else {
          allPrice = Number(allPrice.replace(",", ""));
        }
        break;
      // 通貨が2つある場合
    case "RM MYR":
      allPrice = Number(giftPrice.replace("RM", "").replace(" MYR", ""));
      break;
    case " zł":
    case "QAR ":
      case " lei":
        allPrice = Number(allPrice.replace(",", "")) / 100;
        break;
      case "₫":
        allPrice = Number(allPrice.replace(".", ""));
        break;
      default:
        allPrice = Number(allPrice.replace(",", ""));
        break;
    }
  // 金額Pタグ用
  let newContent;
  // 金額spanタグ用
  let priceSpan;

  for (let i = 0; i < productData.length; i++)
  {
    var newElement = document.createElement("p");
    let price = 0;
    let tittle = productData[i].value;
    Array.from(pTagsProductList).forEach(function(pTagProduct) {
		// 一旦退避
		let textContent = tittle;
		if (2 < textContent.length) {
		let firstThreeDigits = textContent.substring(0, 3);
		// 数字かどうか判定
		if (/^\d+$/.test(firstThreeDigits)) {
		  // 先頭3桁が数字の場合、先頭3桁+1桁を削除して返す
		  textContent = "\"" + textContent.substring(4) + "\"" ;
		}
		}

		// テキストが含まれている場合の処理をここに記述する
		if (pTagProduct.textContent.includes(textContent)) {
		price = pTagProduct.textContent.substring(0, pTagProduct.textContent.indexOf('_'));
		price = Number(price) / 100;
		allPrice += price;
		}
	});

    newContent = document.createTextNode("Variation_" + (i + 1) + ':' + tittle);
    priceSpan = document.createElement("span");
    priceSpan.style.float = "right";

    // 通貨設定編集
    price = getCurrency(price, currency);

    // 通貨記号位置
    priceSpan.appendChild(getCurrencyPosition(giftPrice, price, currency));
    
    newElement.appendChild(newContent);
    newElement.appendChild(priceSpan);
    newElementList.push(newElement);
  }
  // 箱代
  newElement = document.createElement("p");
  newContent = document.createTextNode('BoxPrice');
  priceSpan = document.createElement("span");
  priceSpan.style.float = "right";
  priceSpan.appendChild(document.createTextNode(giftPrice));
  newElement.appendChild(priceSpan);
  newElement.appendChild(newContent);
  newElementList.push(newElement); 

  newElement = document.createElement("p");
  newContent = document.createTextNode('Total');
  priceSpan = document.createElement("span");
  priceSpan.style.float = "right";

  // 通貨設定編集
  allPrice = getCurrency(allPrice, currency);

  // 通貨記号位置
  priceSpan.appendChild(getCurrencyPosition(giftPrice, allPrice, currency));
  
  newElement.appendChild(priceSpan);
  newElement.appendChild(newContent);
  newElementList.push(newElement); 

  while(divElement.firstChild) {
    divElement.removeChild(divElement.firstChild);
  }

  // 新しい<p>要素のリストを一括で追加
  newElementList.forEach(function(newElem) {
      divElement.appendChild(newElem);
  });
}

// 通貨表示設定
function getCurrency(price, currency) {
  switch (currency) {
    case "€" :
      // カンマは小数点扱いらしい。
      return price.toLocaleString().replace(".", ",");
    case "DA " :
    case "Tk " :
    case " лв" :
    case "KHR" :
    case "LE " :
    case "£" :
    case "L " :
    case "Rs. " :
    case "L£" :
    case "CHF " :
    case "MOP$" :
    case "Rs " :
    case "Rs" :
    case " dh" :
    case "₦" :
    case "ден " :
    case "S/. ":
    case " SR":
    case " ฿":
    case "Dhs. ":
    case "RM MYR" ://通貨単位が2つある
      return price.toLocaleString() + ".00";
    case "₡ " :
    case "Rp " :
      return price.toLocaleString().replace(",", ".") + ",00";
    case " Kč" :
    case " zł" :
    case "QAR ":
      case " lei":
    return price.toLocaleString() + ",00";
    case " kr" :
      switch(Shopify.currency.active) {
        case "DKK" :
          return price.toLocaleString() + ".00";
        default:
          return price.toLocaleString().replace(",", ".");;
        }
    case " Fdj" :
    case " Ft" :
    case "Gs. " :
    case "₫" :
    return price.toLocaleString().replace(",", ".");
    case " XPF" :
      return price.toLocaleString().replace(",", " ")
      case "$" :
        switch(Shopify.currency.active) {
          // 通貨ドルで「,」がある。
          case "UYU" :
            return price.toLocaleString()+ ",00";;
          default:
            return price.toLocaleString() + ".00";
          }
  
      

      default : 
      switch(Shopify.currency.active) {
        // 通貨円で.00がある。
        case "CNY" :
          return price.toLocaleString() + ".00";
        default:
          return price.toLocaleString();
        }
    }
}

// 通貨記号位置
function getCurrencyPosition(giftPrice, price, currency) {
  // マレーシアの場合
  if (currency == "RM MYR") {
    // 合計 + 通貨記号
    return document.createTextNode("RM" + price + " MYR");
  }

  // 後ろに通貨をつける場合
  if (0 != giftPrice.indexOf(currency)) {
    // 合計 + 通貨記号
    return document.createTextNode(price + currency);
  }
  else{
    // 通貨記号 + 合計
    return document.createTextNode(currency + price);
  }
}
// レスポンシブの場合にヘッダーがカクカクしないようにする為の対応
window.addEventListener('scroll', function() {
  var element = document.querySelector('.header-custom-menu');

  if (element == null)
  {
      return;
  }

  var scrollPosition = window.scrollY;

  // 特定のスクロール位置に達した場合にスタイルを変更する
  if(element.style.display != 'none')
  {
    if (scrollPosition >= 60) {
      element.style.display = 'none';
    }
  }
  else
  {
    if (scrollPosition <= 5) {
      element.style.display = '';
    }
  }
});
//メニューリンクを別タブで開く
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
